const filterEmptyLists = ({ inputType, list }: any) =>
  !(inputType === 'autocomplete' && list.length === 0);

// Removes fields with empty lists under right conditions
const filterFields = (steps: any) => {
  return steps.map(({ fields, ...step }: any) => {
    return Object.assign(step, { fields: fields.filter(filterEmptyLists) });
  });
};

export default filterFields;
try {
    // @ts-ignore
    filterFields.displayName = "filterFields";
    // @ts-ignore
    filterFields.__docgenInfo = { "description": "", "displayName": "filterFields", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/stepContainer/dataTransform/filterFields.ts#filterFields"] = { docgenInfo: filterFields.__docgenInfo, name: "filterFields", path: "src/containers/stepContainer/dataTransform/filterFields.ts#filterFields" };
}
catch (__react_docgen_typescript_loader_error) { }